/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';

import { Icon, ModalFull, Text, TouchableLink } from './uiold';
import { themeColors } from './uiold/Constants';
import { disablePageScroll, enablePageScroll } from '../support/Utils';
import { DocumentTypes, ImageTypes } from '../core/constants/MimeTypes';
import { getFileURL, getDownloadURL } from '../support/helpers/Files';
import PreviewImage from './Preview/PreviewImage';
import PreviewDocument from './Preview/PreviewDocument';

import { FileDesc } from '../types/shared/FileDesc';

type Props = {
  file: FileDesc;
  onClose: (...args: Array<any>) => any;
  disablePageScroll?: boolean;
  isModal?: boolean;
};

class Preview extends Component<Props> {
  _pageScrollIsDisabled = false;

  constructor(props: Props) {
    super(props);
    if (this.props.disablePageScroll) {
      disablePageScroll();
      this._pageScrollIsDisabled = true;
    }
  }

  componentDidMount() {
    document.addEventListener('keyup', this._onKeyUp);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this._onKeyUp);
    if (this._pageScrollIsDisabled) {
      enablePageScroll();
    }
  }

  render() {
    let { file } = this.props;
    let preview;
    if (ImageTypes[file.type]) {
      preview = <PreviewImage src={getFileURL(file, { size: 'large' })} />;
    } else if (DocumentTypes[file.type]) {
      preview = <PreviewDocument {...this.props} />;
    } else {
      preview = this._renderError(t('Invalid File Type'));
    }
    let component = (
      <ModalFull
        isVisible
        useNonDefaultComponent
        onClose={this._hideDialog}
        closeButtonStyle={{ top: 8 }}
      >
        <ModalFull.Header style={styles.modalHeader}>
          <View style={styles.headerView}>
            <View style={styles.leftHeader}>
              <View style={styles.justifyCenter}>
                <Icon
                  name="description"
                  size="S"
                  color={themeColors.white}
                  style={styles.iconStyle}
                />
              </View>
              <Text type="label" style={styles.headerTitle}>
                {file.name}
              </Text>
            </View>
            <View style={styles.rightHeader}>
              <View style={{ marginTop: 4 }}>
                <TouchableLink href={getDownloadURL(file)} download={true}>
                  <Icon
                    name="download"
                    size="S"
                    color={themeColors.white}
                    style={styles.downloadIcon}
                  />
                </TouchableLink>
              </View>
            </View>
          </View>
        </ModalFull.Header>
        <ModalFull.Body style={styles.previewWrapper}>{preview}</ModalFull.Body>
      </ModalFull>
    );
    return component;
  }

  _renderError = (text: string) => {
    return (
      <div className="error">
        <p>{text}</p>
      </div>
    );
  };

  _hideDialog = () => {
    this.props.onClose();
  };

  _onOverlayClick = (event: { [key: string]: any }) => {
    if (event.target.tagName.toLowerCase() !== 'img') {
      this.props.onClose();
    }
  };

  _onKeyUp = (event: { [key: string]: any }) => {
    if (event.keyCode === 27) {
      this.props.onClose();
    }
  };
}

let styles = StyleSheet.create({
  modalHeader: {
    backgroundColor: themeColors.black,
    borderBottomWidth: 0,
  },
  headerTitle: {
    fontWeight: '300',
    color: themeColors.white,
  },
  headerView: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  leftHeader: {
    flex: 1,
    flexDirection: 'row',
  },
  rightHeader: {
    flex: 1,
    flexDirection: 'row-reverse',
    marginRight: 30,
  },
  justifyCenter: {
    justifyContent: 'center',
  },
  iconStyle: {
    marginRight: 6,
    marginTop: 1,
  },
  downloadIcon: {
    marginRight: 6,
    marginTop: 1,
  },
  previewWrapper: {
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default Preview;
